import { useQuery } from '@tanstack/react-query';

import { axios } from 'lib/axios';
import { qnaKey } from './queryKeys';

const getQnaSummary = (resource, id) => axios.get(`/api/${resource}/${id}/qna/summary`);

export const useQnaSummary = (resource, id, options = {}) =>
  useQuery({
    queryKey: qnaKey(resource, id, 'summary'),
    queryFn: () => getQnaSummary(resource, id),
    select: ({ data }) => data.data,
    retry: false,
    ...options,
  });
